import { Component, HostBinding, Input, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { BrandsEnum, IconSizeEnum, ImageRatioEnum, SdBannerComponent, SdIconComponent, SdLinkComponent } from '@seb/web-design-system/core';

import type { IDevice } from './device.interface';

@Component({
  selector: 'sd-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdBannerComponent,
    SdLinkComponent,
    NgTemplateOutlet,
    SdIconComponent
  ]
})
export class SdDeviceComponent {
  iconSize = IconSizeEnum;
  imageRatioEnum = ImageRatioEnum;

  @Input()
  brand: BrandsEnum;

  @Input()
  device: IDevice;

  @Input()
  isSmall = false;

  @Input()
  isHovered = true;

  @Output()
  deviceIsClicked = new EventEmitter<void>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.isSmall ? 'is-small' : '',
      this.isHovered ? 'is-hovered' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  onClickedDevice() {
    this.deviceIsClicked.emit();
  }
}
